// extracted by css-extract-rspack-plugin
export default {"container":"R7lsFX6UU5fajQPq"};